import React from 'react';
import LabelSettings from './components/label-settings';
import AssignPhoneNumberSettings from './components/assign-phone-number-settings';
import CallForwardingSettings from './components/call-forwarding-settings/call-forwarding-settings';
import CallRecordingSettingsContainer from './components/call-recording-settings/call-recording-settings-container';
import VoicemailGreetingSettingsContainer from './components/voicemail-greeting-settings/voicemail-greeting-settings-container';
import hasPermission from '../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../shared/utils/access-control/enums/permissions';

const PhoneNumberSettingsContent: React.FC = () => (
  <>
    <LabelSettings />
    {hasPermission(Permissions.PHONE_NUMBER_ASSIGNMENT_UPDATE) && (
      <AssignPhoneNumberSettings />
    )}
    <CallForwardingSettings />
    <CallRecordingSettingsContainer />
    <VoicemailGreetingSettingsContainer />
  </>
);

export default PhoneNumberSettingsContent;